import React from 'react';
import { Button, Modal } from 'antd';
import CreateExclusionJobModalContent from './CreateExclusionJobModalContent';
import { FormProvider, useForm } from 'react-hook-form';
import { useCreateEmailExclusionJob } from './hooks';
import { CreateEmailExclusionJobContext } from './context';

export default function CreateExclusionJobButton() {
  const [visible, setVisible] = React.useState(false);
  const form = useForm({
    defaultValues: {
      exclusionFiles: [],
      campaignFiles: [],
    },
  });
  const { mutate, isLoading, progress } = useCreateEmailExclusionJob();
  return (
    <CreateEmailExclusionJobContext.Provider
      value={{ progress, isUploading: isLoading }}
    >
      <FormProvider {...form}>
        <Button icon="plus" onClick={() => setVisible(true)}>
          Create Exclusion Job
        </Button>
        <Modal
          okButtonProps={{
            disabled: isLoading,
            loading: isLoading,
            onClick: form.handleSubmit(async data => {
              await mutate(data)
                .then(() => {
                  form.reset();
                  setVisible(false);
                })
                .catch(() => {});
            }),
          }}
          title="Create Exclusion Job"
          visible={visible}
          width={800}
          onCancel={() => setVisible(false)}
        >
          <CreateExclusionJobModalContent />
        </Modal>
      </FormProvider>
    </CreateEmailExclusionJobContext.Provider>
  );
}
